module.exports = __webpack_public_path__ + "static/media/instrumentacion-03.6cb23166.jpg";